export default {
  'es-ES': {
    ACCESS: 'Acceder',
    ACCOUNT_HOLDER: 'Titular cuenta',
    ADD: 'Añadir',
    ADDONS: 'Extras',
    ADDRESS: 'Dirección',
    AFFILIATE: 'Afiliado',
    AFFILIATE_ID: 'ID afiliado',

    BANK_NAME: 'Entidad bancaria',
    BOOKING: 'Reserva',
    BOOKINGS: 'Reservas',

    CAMPAIGN: 'Campaña',
    CAMPAIGN_NAME_HINT: 'Lo necesitarás para gestionarla',
    CAMPAIGNS: 'Campañas',
    CAMPAIGN_TYPE: '¿Qué tipo de campaña quieres?',
    CAMPAIGN_TYPE_LINK: 'Link',
    CAMPAIGN_TYPE_WIDGET: 'Widget',
    CANCELLATIONS: 'Cancelaciones',
    CATEGORIES: 'Categorias',
    CATEGORY: 'Categoría de actividades',
    CHOOSE_DATE: 'Selecciona las fechas...',
    CITY: 'Ciudad',
    CLONE: 'Clonar',
    CONVERSION: 'Conversión',
    COUNTRY: 'País',
    CREATE: 'Crear',
    CREATED: 'Fecha creación',

    DATE: 'Fecha',
    DATES: 'Fechas',
    DATE_CREATED: 'Fecha registro',
    DATE_USED: 'Fecha disfrute',
    DELETE: 'Eliminar',
    DESTINATION: 'Destino',
    DESTINATION_HINT: 'Ejemplo: Barcelona, Ibiza, Italia',
    DICTIONARY: 'Diccionario',
    DOCUMENT: 'Documento',
    DOMAINS: 'Dominios en los que aparecerá',
    DOMAINS_PLACEHOLDER: 'Ej. miblog.com',

    EDIT: 'Editar',
    EDIT_CAMPAIGN: 'Editar campaña',
    ERROR_SIGNIN_TEXT: 'El e-mail introducido y la contraseña no coinciden',
    ERROR_SIGNIN_TITLE: 'Error al iniciar sesión',
    EVENT: 'Evento',
    EVENTS: 'Eventos',
    EXPERIENCE: 'Actividad',
    EXPERIENCES: 'Experiencias',
    EXPERIENCES_EMPTY: 'Por favor, introduce un destino válido',

    FEE: 'Comisión',
    FIRST_NAME: 'Nombre',
    FREE: 'Gratis',
    FROM: 'Desde',
    FULL_NAME: 'Nombre completo',

    HOME: 'Inicio',
    HOWTO_LINK_TITLE: 'Cómo enlazar URLs',
    HOWTO_LINK_SUMMARY: 'Añade tu ID de afiliado y el nombre de la campaña al final de la URL de la actividad o destino que desees enlazar siguiendo el formato que te mostramos aquí abajo.',
    HOWTO_LINK_URL: 'URL que desees enlazar',
    HOWTO_LINK_URL_HINT: 'Copia y pégalo al final de la URL que desees enlazar',
    HOWTO_LINK_EXAMPLE_1: 'Ejemplo de enlace a una excursión a la Alhambra',
    HOWTO_LINK_EXAMPLE_2: 'Ejemplo de enlace a excursiones en Granada',
    HOWTO_LINK_WARNING: 'IMPORTANTE\n Hay una pequeña parte de actividades que NO se incluyen en el programa de afiliados y que, por tanto, no puedes enlazar. Son las que pertenecen a otros proveedores como Civitatis o GetYourGuide, puedes identificarlas cuando aparezca esta información. Recuerda no usar estos enlaces.',
    HOWTO_WIDGET_TITLE: 'Cómo añadir el widget a tu web',
    HOWTO_WIDGET_SUMMARY: 'Pega el iFrame que te mostramos aquí abajo en el html de tu web. Se ajustará automáicamente al ancho de tu página. Podrás utilizarlo en todas las secciones que desees.',
    HOWTO_WIDGET_HINT: 'Pega este iFrame en el html de tu web',

    INDIVIDUALS: 'Individuos',
    INFO_CAMPAIGN_UPDATED_TEXT: 'Tu campaña se ha actualizado correctamente',
    INFO_CAMPAIGN_SAVED_TEXT: 'Tu campaña se ha guardado correctamente',
    INFO_PROFILE_TEXT: 'Tu perfil se ha actualizado correctamente',
    INFO_SAVED: 'Guardado',
    INFO_UPDATED: 'Actualizado',
    INVOICED: 'Fecha Facturación',
    INVOICES: 'Facturas',
    INVOICE_ADDRESS: 'Dirección Facturación',
    INVOICING: 'Facturación',

    KEY: 'key',

    LANGUAGES: 'Idiomas',
    LAST_NAME: 'Apellidos',
    LOGOUT: 'Cerrar sesion',

    MONTHS: 'enero,febrero,marzo,abril,mayo,junio,julio,agosto,septiembre,octubre,noviembre,diciembre',

    NAME: 'Nombre',
    NAME_CAMPAIGN: 'Dale un nombre a tu campaña',
    NEW: 'Nueva',
    NEXT_INVOICES: 'Próximas facturas',
    NUMBER: 'Número',

    PAGE: 'Pagina',
    PASSWORD: 'Contraseña',
    PASSWORD_REPEAT: 'Repita Contraseña',
    PAYMENT: 'Pago',
    PENDING: 'Pendiente',
    PERIOD: 'Selecciona un periodo',
    PERIOD_CAMPAIGN: 'Elige un periodo (opcional)',
    PERIOD_DATASOURCE: 'Hoy,Última semana,Último mes,Último año,Personalizado',
    PHONE: 'Teléfono',
    PREVIEW: 'Vista previa',
    PREVIEW_CAPTION: 'Selecciona las actividades que quieras incluir en tu widget',
    PROFILE: 'Perfil',

    REMOVE_ALL: 'Borrar selección',

    SAVE: 'Guardar',
    SEARCH: 'Buscar',
    SELECT: 'Seleccionar',
    SELECT_ALL: 'Seleccionar todas',
    SELECTED: 'Seleccionada',
    SIGN_IN_TITLE: 'Login',
    SIGN_IN_CAPTION: 'Introduce tus datos de acceso para acceder a tu panel de afiliado.',
    SIGN_IN_LINK: '$l10n.SIGN_IN_LINK',
    SIGN_UP_TITLE: '$l10n.SIGNUP_TITLE',
    SIGN_UP_CAPTION: '$l10n.SIGN_UP_CAPTION Introduce tus datos de acceso para acceder a tu panel de afiliado.',
    SIGN_UP_LINK: '$l10n.SIGN_UP_LINK',
    STATE: 'Estado',
    STATS: 'Estadísticas',
    STORY: 'Story',
    STREET: 'Calle',

    TOTAL: 'Total',
    TOTAL_INVOICED: 'Total facturado',
    TOTAL_PENDING: 'Total pendiente',
    TYPE: 'Tipo',

    VIEW_INFO: 'Ver info',

    ZIP: 'Codigo Postal',
  },

  'en-EN': {
    ACCESS: 'Access',
    ACCOUNT_HOLDER: 'Account holder',
    ADD: 'Add',
    ADDONS: 'Addons',
    ADDRESS: 'Address',
    AFFILIATE: 'Affiliate',
    AFFILIATE_ID: 'Affiliate ID',

    BANK_NAME: 'Bank name',
    BOOKING: 'Reserva',
    BOOKINGS: 'Bookings',

    CAMPAIGN: 'Campaign',
    CAMPAIGN_NAME_HINT: 'It will help you to monitor its performance',
    CAMPAIGNS: 'Campaigns',
    CAMPAIGN_TYPE: 'What kind of campaign do you want?',
    CAMPAIGN_TYPE_LINK: 'Link',
    CAMPAIGN_TYPE_WIDGET: 'Widget',
    CANCELLATIONS: 'Cancellations',
    CATEGORIES: 'Categories',
    CATEGORY: 'Category',
    CHOOSE_DATE: 'Choose date...',
    CITY: 'City',
    CLONE: 'Clone',
    CONVERSION: 'Conversion',
    COUNTRY: 'Country',
    CREATE: 'Create',
    CREATED: 'Created',

    DATE: 'Date',
    DATES: 'Dates',
    DATE_CREATED: 'Fecha registro',
    DATE_USED: 'Fecha disfrute',
    DELETE: 'Delete',
    DESTINATION: 'Destination',
    DESTINATION_HINT: 'Ex. Barcelona, Torre Eiffel, Italia',
    DICTIONARY: 'Dictionary',
    DOCUMENT: 'Documento',
    DOMAINS: 'Domains',
    DOMAINS_PLACEHOLDER: 'Ex. myblog.com',

    EDIT: 'Edit',
    EDIT_CAMPAIGN: 'Edit campaign',
    ERROR_SIGNIN_TEXT: '$ERROR_SIGNIN_TEXT',
    ERROR_SIGNIN_TITLE: '$ERROR_SIGNIN_TITLE',
    EVENT: 'Event',
    EVENTS: 'Events',
    EXPERIENCE: 'Experience',
    EXPERIENCES: 'Experiences',
    EXPERIENCES_EMPTY: 'Please, input a valid destination.',

    FEE: 'Fee',
    FIRST_NAME: 'First name',
    FREE: 'Free',
    FROM: 'From',
    FULL_NAME: 'Full name',

    HOME: 'Home',
    HOWTO_LINK_TITLE: '$HOWTO_LINK_TITLE',
    HOWTO_LINK_SUMMARY: '$HOWTO_LINK_SUMMARY',
    HOWTO_LINK_URL: '$HOWTO_LINK_URL',
    HOWTO_LINK_URL_HINT: '$HOWTO_LINK_URL_HINT',
    HOWTO_LINK_EXAMPLE_1: '$HOWTO_LINK_EXAMPLE_1',
    HOWTO_LINK_EXAMPLE_2: '$HOWTO_LINK_EXAMPLE_2',
    HOWTO_LINK_WARNING: '$HOWTO_LINK_WARNING',
    HOWTO_WIDGET_TITLE: '$HOWTO_WIDGET_TITLE',
    HOWTO_WIDGET_SUMMARY: '$HOWTO_WIDGET_SUMMARY',
    HOWTO_WIDGET_HINT: 'HOWTO_WIDGET_HINT',

    INDIVIDUALS: 'Individuals',
    INFO_CAMPAIGN_UPDATED_TEXT: '$INFO_CAMPAIGN_UPDATED_TEXT',
    INFO_CAMPAIGN_SAVED_TEXT: '$INFO_CAMPAIGN_SAVED_TEXT',
    INFO_PROFILE_TEXT: '$INFO_PROFILE_TEXT',
    INFO_SAVED: '$INFO_SAVED',
    INFO_UPDATED: '$INFO_UPDATED',
    INVOICED: 'Invoiced',
    INVOICES: 'Invoices',
    INVOICE_ADDRESS: 'Invoice Address',
    INVOICING: 'Invoicing',

    KEY: 'key',

    LANGUAGES: 'LANGUAGES',
    LAST_NAME: 'Last Name',
    LOGOUT: 'Logout',

    MONTHS: 'january,february,march,april,may,june,july,august,september,october,november,december',

    NAME: 'Name',
    NAME_CAMPAIGN: 'Campaign name',
    NEW: 'New',
    NEXT_INVOICES: 'Next invoices',
    NUMBER: 'Number',

    PAGE: 'Page',
    PASSWORD: 'Password',
    PASSWORD_REPEAT: 'Repeat password',
    PAYMENT: 'Payment',
    PENDING: 'Pending',
    PERIOD: 'Period',
    PERIOD_CAMPAIGN: 'Campaign period',
    PERIOD_DATASOURCE: 'Today,Last week,Last month,Last year,Customized',
    PHONE: 'Phone',
    PREVIEW: 'Preview',
    PREVIEW_CAPTION: 'Select the experiences you would like include in your widget.',
    PROFILE: 'Profile',

    REMOVE_ALL: 'Remove All',

    SAVE: 'Save',
    SEARCH: 'Search',
    SELECT: 'Select',
    SELECT_ALL: 'Select all',
    SELECTED: 'Selected',
    SIGN_IN_TITLE: '$SIGN_IN_TITLE',
    SIGN_IN_CAPTION: '$SIGN_IN_CAPTION Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys...',
    SIGN_IN_LINK: '$l10n.SIGN_IN_LINK',
    SIGN_UP_TITLE: '$l10n.SIGNUP_TITLE',
    SIGN_UP_CAPTION: '$l10n.SIGN_UP_CAPTION',
    SIGN_UP_LINK: '$l10n.SIGN_IN_LINK',
    STATE: 'State',
    STATS: 'Stats',
    STORY: 'Story',
    STREET: 'Street',

    TOTAL: 'Total',
    TOTAL_INVOICED: 'Total invoiced',
    TOTAL_PENDING: 'Total pending',
    TYPE: 'Type',

    VIEW_INFO: 'View Info',

    ZIP: 'Zip',
  },
};
